<template>
  <v-app>
    <MenuHeaderCustomer />
    <v-main>
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
      <IntercomCustomers />
    </v-main>
  </v-app>
</template>

<script>
import { MenuHeaderCustomer } from "./components";
export default {
  name: "Customer",
  middleware: "customer",
  components: {
    MenuHeaderCustomer,
  },
  mounted() {
    this.$store.dispatch("loading/done");
  },
};
</script>
